import React from 'react';
import { Col, Container, Row } from "reactstrap";
import title from '../assets/img/index/title.png'
import logo1 from '../assets/img/index/logo1.png'
import logo2 from '../assets/img/index/logo2.png'
import logo3 from '../assets/img/index/logo3.png'
import './css/index.css'
import TopLink from './component/TopLink';

const Faq = (props) => {
    const buttons = [
        { link: '/', name: 'خانه', color: '#289bd6' },
        { link: '/faq', name: 'قوانین و مقررات', color: '#1794d2' },
        { link: '/', name: 'میز خدمت', color: '#0083c7' },
        { link: '/admin/dashboard', name: 'داشبورد مدیریتی رصد آسیب های اجتماعی', color: '#007fc1' },
        { link: '/', name: 'سازمان های همکار', color: '#0071b0' },
        { link: '/', name: 'اخبار', color: '#005f96' }
    ]
    return (
        <div className="content">
            <div id="top-menu" className="text-center">
                <Row>
                    <Col sm="1"></Col>
                    <Col sm="10">
                        {buttons && buttons.map((b, i) => (
                            <TopLink link={b.link}
                                color={b.color}
                                name={b.name}
                            />
                        ))
                        }</Col>
                    <Col sm="1"></Col>
                </Row>
            </div>
            <div id="background">
                <Row>
                    <Col sm="3"><img className={'logo1'} src={logo1} alt="logo2" /></Col>
                    <Col sm="6"></Col>
                    <Col sm="3" className="text-right"><img className={'logo2'} src={logo3} alt="logo2" /></Col>
                </Row>
            </div>
            <Container fluid className={'indexContent roya'}>
                <Row className={'header'}>
                    <img className={'titleimg'} src={title} alt="title" />
                </Row>
                <Row>
                    <Col md={2} >

                    </Col>
                    <Col md={8} className={'text-justify roya  brief-description'}>
                        <h2>قوانین و مقررات مرتبط با سامانه رصد آسیب های اجتماعی
                            (سراج)</h2>
                        <h4 className="text-bold">
                            ۱) بند ی از ماده ۴ و بند د از ماده ۹ قانون ساختار نظام جامع رفاه و تامین اجتماعی
                            مصوب ۱۳۸۲ مجلس شورای اسلامی مصوب ۱۳۹۵ مجلس شورای اسلامی</h4>
                        <p>
                            ماده ۴- اهداف و وظایف حوزه حمایتی و توانبخشی به شرح زیر می باشد:
                            <br />
                            ی ـ تامین خدمات پیشگیری از بروز یا تشدید معلولیت ها و آسیب های اجتماعی در گروههای
                            هدف و تحت پوشش قرار دادن آنها در سه سطح پیشگیری، درمان و توانبخشی.
                        </p>
                        <p>ماده ۹- اصول و سیاستهای اجرایی نظام جامع تامین اجتماعی به شرح زیر می باشد:<br />
                            د ـ سیاست پیشگیری: اعمال این سیاست شامل هرسه حوزه بیمه ای، حمایتی و امدادی می باشد و
                            مطابق آن بر ضرورت هماهنگی با سایر دستگاههای موثر تاکید می شود به نحوی که تلاش برای
                            پیشگیری از ظهور یا گسترش انحرافات و مشکلات اجتماعی به عنوان یک سیاست هماهنگی فرابخشی
                            مبنای عمل قرار گیرد.
                        </p>
                        <h4 className="text-bold">۲) جزء ۴ و ۸ از بند پ ماده ۵۷ قانون احکام دائمی برنامه های توسعه کشور مصوب ۱۳۹۵ مجلس
                            شورای اسلامی</h4>
                        <p>ماده۵۷<br />
                            پ ـ دولت مكلف است به‌منظور رفع فقر و نابرابري، بسط و ترويج سبك زندگي اسلامي ـ
                            ايراني، ايجاد زمينه تضمين حداقل حمايت‌هاي اجتماعي، تأمين حداقل كيفيت زندگي و پيشگيري
                            از بروز آسيبهاي اجتماعي، وفق تبصره ذيل ماده(۱۶) قانون ساختار نظام جامع رفاه و تأمين
                            اجتماعي مصوب ۲۲/۰۲/۱۳۸۲ ضمن تجميع و ساماندهي شوراهاي مرتبط با امور سالمندان، كودكان،
                            معلولان و نظاير آن در شوراي راهبردي و تخصصي امور حمايتي در زيرمجموعه شوراي‌عالي رفاه
                            و تأمين اجتماعي نسبت به انجام امور زير در قالب برنامه‌هاي اجتماع‌محور و خانواده‌محور
                            و با استفاده حداكثري از مشاركت‌هاي مردمي و همكاري‌هاي جمعي اقدام كند:<br />
                            ….۴- ايجاد مركز اطلاعات و مطالعات آسيبهاي اجتماعي به‌منظور پايش و پيمايش انواع
                            آسيبهاي اجتماعي و شناسايي گروهها و اقشار هدف۰۰۰۰<br />
                            ۸ ـ سازمان بهزيستي كشور متولي سلامت اجتماعي با رويكرد پيشگيري از آسيبهاي اجتماعي و
                            مداخله در بحران‌هاي اجتماعي، ارائه خدمات حمايتي و توانبخشي به كليه معلولان، مددجويان
                            و گروههاي آسيب‌پذير از قبيل زنان، كودكان، سالمندان نيازمند جامعه مي‌باشد.</p>
                        <h4 className="text-bold">
                            ۳) جزء ۴ از بند الف ماده ۸۰ قانون برنامه پنجساله ششم توسعه کشور مصوب ۱۳۹۵ مجلس شورای
                            اسلامی</h4>
                        <p>ماده ۸۰-&nbsp;دولت مکلف است طبق قوانین مربوطه و مصوبات شورای اجتماعی به منظور پیشگیری
                            و کاهش آسیبهای اجتماعی، نسبت به تهیه طرح جامع کنترل و کاهش آسیب‌های اجتماعی با
                            اولویت اعتیاد، طلاق، حاشیه‌نشینی، کودکان کار و مفاسد اخلاقی مشتمل بر محورهای ذیل
                            اقدام کند به‌گونه‌ای که آسیبهای اجتماعی در انتهای برنامه به بیست و پنج درصد (۲۵%)
                            میزان کنونی کاهش یابد:<br />
                            الف- پیشگیری<br />
                            …..۴- «تدوین نظام جامع رصد آسیبهای اجتماعی و معلولیت‌ها» تا پایان سال اول اجرای
                            قانون برنامه طبق قوانین مربوطه و تصویب شورای اجتماعی و اجرای آن از ابتدای سال
                            دوم اجرای قانون برنامه</p>
                        <h4 className="text-bold">۴) پیوست شماره ۲ نظام جامع رصد آسیب های اجتماعی ،موضوعِ ِ ماده ۵ نظام جامع رصد آسیب
                            های اجتماعی مصوب ۱۳۹۸ شورای اجتماعی کشور</h4>
                        <p>(تولید یا ثبت داده های اجتماعی ، نگهداری و تمیز داده های اجتماعی توسط سازمان بهزیستی
                            از طریق سامانه سراج ( رصد اجتماعی) )</p>

                    </Col>
                    <Col md={2}>
                    </Col>
                </Row>
                <Row className={"justify-content-center"}>
                    <Col>&nbsp;</Col>
                </Row>
                <Row className={'home-footer'}>
                    <Col sm={2}>
                    </Col>
                    <Col sm={4} className="text-right">
                        <i className="botton-icon fa fa-home"></i><span className="address"> تهران، میدان امام خمینی(ره)، خیابان فیاض‌بخش، شماره ۱۱۲۱ <br />سازمان بهزیستی کشور</span>
                    </Col>
                    <Col sm={4} className="text-right">
                        <Row>
                            <Col>
                                <i className="botton-icon fa fa-phone"></i><span className="address"> 66702001 - 021</span>
                            </Col>
                        </Row>
                        <Row><Col>&nbsp;</Col></Row>
                        <Row>
                            <Col>
                                <i className="botton-icon fa fa-envelope"></i><span className="address"> info@seraj.ir</span>
                            </Col>
                        </Row>
                    </Col>
                    <Col sm={2}>
                    </Col>
                </Row>
                <Row className={'copyrigth'}>
                    <Col className="text-center">
                        کلیه حقوق مادی و معنوی این سایت متعلق به دبیرخانه ملی رصد آسیب های اجتماعی می باشد
                    </Col>
                </Row>

            </Container>
        </div>
    )
};

export default Faq;